/* eslint-disable no-console */
type ReduxActionSummary = {
  type: string;
  requestId?: string;
  requestStatus?: string;
  error?: string;
};

type ReduxAction = {
  type?: string;
  meta?: {
    requestId?: string;
    requestStatus?: string;
  };
  error?: {
    message?: string;
  };
};

export const summarizeReduxAction = (action: ReduxAction): ReduxActionSummary => {
  const summary: ReduxActionSummary = {
    type: action?.type ?? 'unknown',
  };

  if (action.meta?.requestId) {
    summary.requestId = action.meta.requestId;
  }
  if (action.meta?.requestStatus) {
    summary.requestStatus = action.meta.requestStatus;
  }
  if (action.error?.message) {
    summary.error = action.error.message;
  }

  return summary;
};

export default () => (next) => (action) => {
  if (process.env.NODE_ENV === "development") {
    console.debug('Redux action', summarizeReduxAction(action));
  }

  return next(action);
};
